import hash from 'object-hash';

export const queryKeyFactory = ctx => {
  return [
    'search',
    ctx.method,
    hash.MD5(ctx.requestsArgs ? ctx.requestsArgs : ctx.requestArgs),
  ];
};
